import { VenetianMask } from "lucide-react";

import type { TIconProps } from "./types";

export const AnonymizationLab = (props: TIconProps): JSX.Element => (
  <VenetianMask
    stroke="var(--fill1)"
    style={{ strokeWidth: "calc(1.5 + var(--nav-glyph-bold, 0) * 1.2)" }}
    {...props}
  />
);
